import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatComponent } from './chat.component';
import { UserImageComponent } from './user-image/user-image.component';
import { UploadDirective } from './directives/upload.directive';
import { ChatImageAttachComponent } from './chat-image-attach/chat-image-attach.component';

// import { PopoverModule } from 'ngx-bootstrap/popover';
// import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { GroupListComponent } from './group-list/group-list.component';
import { MessageComponent } from './message/message.component';
import { GroupMessagesComponent } from './group-messages/group-messages.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TextinputBarComponent } from './textinput-bar/textinput-bar.component';
import { MaterialModule } from './../../material.module';
import { RouterModule} from "@angular/router";
import { EmojiShareModule } from './../../../Components/emojipicker/emoji-share-module';
import { NgxImageSwiperModule } from "ngx-image-swiper";
import { MatBadgeModule } from "@angular/material/badge";
import { BannerZoneMapModule } from 'src/app/Components/banner-zone-map/baner-zone-map.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    RouterModule,
    EmojiShareModule,
    NgxImageSwiperModule,
    MatBadgeModule,
    BannerZoneMapModule
  ],
  declarations: [
    ChatComponent, 
    UserImageComponent, 
    MessageComponent, 
    GroupListComponent, 
    GroupMessagesComponent, 
    TextinputBarComponent,
    UploadDirective, 
    ChatImageAttachComponent,
  ],
  exports: [ChatComponent]
})
export class ChatModule { }